import React from 'react';
import { Typography, Row, Col, Card, Button, Divider, Space, List, Grid, Collapse, Image } from 'antd';
import { 
  RocketOutlined, HeartOutlined, SafetyCertificateOutlined, TeamOutlined, GlobalOutlined, 
  CheckCircleOutlined, QuestionCircleOutlined,
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;
const { useBreakpoint } = Grid;
const { Panel } = Collapse;

const AboutElevateHer = () => {
  const screens = useBreakpoint();

  const galleryImages = [
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.09 (1).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.09 (2).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.09 (3).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.09.jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.10 (1).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.10 (2).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.10.jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.11 (1).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.11 (2).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.11 (3).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.11.jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.12 (1).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.12 (2).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.12.jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.13 (1).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.13 (2).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.13 (3).jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.13.jpeg',
    '/assets/images/gallery/WhatsApp Image 2025-12-19 at 11.17.14.jpeg'
  ];

  const pillars = [
    { title: 'Power', icon: <RocketOutlined />, desc: 'Confidence, voice, and self-belief.', color: '#FE1F08' },
    { title: 'Purpose', icon: <HeartOutlined />, desc: 'Clarity of direction and values.', color: '#FAAD14' },
    { title: 'Presence', icon: <GlobalOutlined />, desc: 'Professionalism, influence, and impact.', color: '#1890ff' },
  ];

  const faqs = [
    { q: "What is the duration?", a: "The programme runs for a defined mentorship cycle, during which mentors and mentees engage through agreed touchpoints." },
    { q: "How often do we meet?", a: "Meeting frequency is mutually agreed upon by each pair, with recommended interactions to ensure impact." },
    { q: "Is it virtual or in person?", a: "ElevateHer primarily operates virtually to allow flexibility and broader participation." },
    { q: "What if I am changing careers?", a: "Yes, you can apply. We support women at different stages, including those navigating transitions." }
  ];

  return (
    <div style={{ background: '#fff', overflowX: 'hidden' }}>
    <img src="/assets/images/elevateher-logo.png" className='img-fluid' alt="ElevateHer Logo" width="200px"/>
      {/* 1. HERO SECTION */}
      <section style={{ 
        padding: screens.xs ? '60px 20px' : '100px 40px', 
        textAlign: 'center', 
        background: 'linear-gradient(135deg, #FE1F08 0%, #7a0b00 100%)',
        color: '#fff',
        borderRadius: screens.xs ? '0' : '0 0 50px 50px',
      }}>
        <Title level={1} style={{ color: '#fff', fontSize: screens.xs ? '32px' : '52px', marginBottom: '16px' }}>
          ElevateHer Mentorship Programme
        </Title>
        <Text style={{ color: '#fff', fontSize: '20px', display: 'block', marginBottom: '24px', opacity: 0.9 }}>
          Empowering Women to Grow, Lead, and Thrive
        </Text>
        <Paragraph style={{ color: '#fff', maxWidth: '850px', margin: '0 auto', fontSize: '18px', lineHeight: '1.6' }}>
          A signature initiative of Chalom Hights, created to support the personal and professional advancement of young women through intentional, structured mentorship.
        </Paragraph>
        <Space size="large" wrap style={{ marginTop: '40px' }}>
          <Button size="large" type="default" style={{ height: '50px', padding: '0 40px' }} onClick={() => window.location.href = '/register'}>Apply Now</Button>
        </Space>
      </section>

      {/* 2. PARTICIPANT BENEFITS */}
      <section style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}>
        <Row gutter={[40, 40]}>
          <Col xs={24} md={12}>
            <Card title={<><TeamOutlined /> Who It Is For</>} bordered={false} className="about-card">
              <Text strong>Mentees:</Text>
              <Paragraph>Young women seeking clarity, confidence, and guidance in their careers and personal growth.</Paragraph>
              <Divider style={{ margin: '12px 0' }} />
              <Text strong>Mentors:</Text>
              <Paragraph>Experienced female leaders passionate about sharing lived experiences and supporting the next generation.</Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card title={<><CheckCircleOutlined /> What You Gain</>} bordered={false} className="about-card">
              <List
                size="small"
                dataSource={[
                  "One-on-one, goal-driven mentorship",
                  "Practical career and leadership guidance",
                  "Increased confidence and self-awareness",
                  "Meaningful connections within a supportive community"
                ]}
                renderItem={item => <List.Item style={{ border: 'none' }}><Text>• {item}</Text></List.Item>}
              />
            </Card>
          </Col>
        </Row>
      </section>

      {/* 3. THE PILLARS */}
      <section style={{ padding: '60px 20px', background: '#fafafa' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <Title level={2}>Our Core Focus</Title>
          <Text type="secondary">ElevateHer is anchored on three essential pillars</Text>
        </div>
        <Row gutter={[24, 24]} justify="center" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {pillars.map(p => (
            <Col xs={24} md={8} key={p.title}>
              <Card hoverable style={{ textAlign: 'center', height: '100%', borderRadius: '15px', borderTop: `5px solid ${p.color}` }}>
                <div style={{ fontSize: '40px', color: p.color, marginBottom: '16px' }}>{p.icon}</div>
                <Title level={3}>{p.title}</Title>
                <Text style={{ fontSize: '16px' }}>{p.desc}</Text>
              </Card>
            </Col>
          ))}
        </Row>
      </section>

      {/* 4. PHOTO GALLERY WITH LIGHTBOX */}
      <section style={{ padding: '60px 20px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <Title level={2}>Community Gallery</Title>
          <Text type="secondary">Click any image to view in full screen</Text>
        </div>
        <Image.PreviewGroup>
          <Row gutter={[16, 16]} justify="center">
            {galleryImages.map((img, index) => (
              <Col xs={12} sm={8} md={6} lg={4} key={index}>
                <div className="gallery-img-container" style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                  <Image 
                    src={img} 
                    alt={`ElevateHer Gallery ${index + 1}`}
                    style={{ objectFit: 'cover', height: '160px', width: '100%' }}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Image.PreviewGroup>
      </section>

      {/* 5. MATCHING & FAQ SECTION */}
      <section style={{ padding: '60px 20px', background: '#f0f2f5' }}>
        <Row gutter={[60, 40]} style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <Col xs={24} lg={12}>
            <Title level={2}>How Matching Works</Title>
            <Paragraph>
              Every match is carefully curated to ensure relevance, alignment, and impact, considering:
            </Paragraph>
            <List
              dataSource={[
                "Career stage and background",
                "Personal development goals",
                "Industry exposure and interests",
                "Leadership aspirations"
              ]}
              renderItem={item => <List.Item style={{ border: 'none' }}><Text><SafetyCertificateOutlined style={{ color: '#FE1F08' }} /> {item}</Text></List.Item>}
            />
          </Col>
          <Col xs={24} lg={12}>
            <Title level={2}><QuestionCircleOutlined /> FAQs </Title>
            <Collapse accordion ghost>
              {faqs.map((f, i) => (
                <Panel header={<Text strong>{f.q}</Text>} key={i}>
                  <p>{f.a}</p>
                </Panel>
              ))}
            </Collapse>
          </Col>
        </Row>
      </section>

      {/* 6. CODE OF CONDUCT */}
      <section style={{ padding: '60px 20px', textAlign: 'center' }}>
        <Title level={2} style={{ fontSize: '40px', color: '#FE1F08', marginBottom: '20px' }}>Programme Code of Conduct</Title>
        <Paragraph style={{ maxWidth: '700px', margin: '0 auto 30px' }}>
          Built on trust, respect, and shared accountability. All participants are expected to uphold these principles.
        </Paragraph>
        <Row gutter={[16, 16]} justify="center" style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {['Mutual Respect', 'Confidentiality', 'Accountability', 'Ethical Conduct'].map(val => (
            <Col xs={12} md={6} key={val}>
              <Card size="small" style={{ borderRadius: '10px', background: '#fff1f0' }}>{val}</Card>
            </Col>
          ))}
        </Row>
      </section>

      {/* 7. FINAL CALL TO ACTION */}
      <section style={{ padding: '80px 20px', textAlign: 'center', background: '#FE1F08', color: '#fff' }}>
        <Title level={2} style={{ color: '#fff' }}>Take the Next Step</Title>
        <Paragraph style={{ color: '#fff', fontSize: '18px' }}>
          Whether you are seeking guidance or looking to give back, ElevateHer offers a meaningful way to grow.
        </Paragraph>
        <Space size="large" wrap style={{ marginTop: '20px' }}>
          <Button size="large" type="default" style={{ height: '50px', padding: '0 40px' }} onClick={() => window.location.href = '/register'}>Apply Now</Button>
        </Space>
      </section>
    </div>
  );
};

export default AboutElevateHer;